/* eslint-disable max-len */
import 'react';

const WarningNewSvg = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="mask0_10454_1853" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
            <rect width="48" height="48" fill="black" />
        </mask>
        <g mask="url(#mask0_10454_1853)">
            <path d="M24 6C33.9411 6 42 14.0589 42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6Z" fill="#FFAA33" />
            <path d="M24 27.25V16" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24 34C24.8284 34 25.5 33.3284 25.5 32.5C25.5 31.6716 24.8284 31 24 31C23.1716 31 22.5 31.6716 22.5 32.5C22.5 33.3284 23.1716 34 24 34Z" fill="white" />
        </g>
    </svg>
);

export default WarningNewSvg;
